import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { Toggle } from 'components/Toggle';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import './FormToggle.scss';
/**
 * @component FormToggle
 * @since 1.0.0
 */
export function FormToggle(props) {
    let { name, size, style, picto, badge, label, infos, error, options, required, disabled } = Object.assign({ style: 'normal' }, props);
    const form = useForm();
    const [ident] = useIdent('form-toggle');
    const [value, setValue] = useValue(name, props.value, '');
    const [focused, setFocused] = useState(false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
        if (props.onChange) {
            props.onChange(value);
        }
    }
    useIf(focused, props.onFocus, props.onBlur);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-toggle', 'form-toggle--' + size, 'form-toggle--' + style, { 'form-toggle--is-required': required }, { 'form-toggle--is-disabled': disabled }, { 'form-toggle--is-focused': focused }, { 'form-toggle--has-label': label }, { 'form-toggle--has-value': value }, { 'form-toggle--has-picto': picto }, { 'form-toggle--has-badge': badge }, { 'form-toggle--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-toggle-field" },
            React.createElement("div", { className: "form-toggle-field-head" },
                React.createElement(FormFieldLabel, { className: "form-toggle-label", size: size, style: style, label: label, ident: ident, required: required, disabled: disabled }),
                React.createElement(FormFieldInfos, { className: "form-toggle-infos", size: size, style: style, infos: infos })),
            React.createElement("div", { className: "form-toggle-field-body" },
                React.createElement(Toggle, { value: value, options: options, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange }),
                picto && React.createElement(Icon, { className: "form-toggle-picto", value: picto }),
                badge && React.createElement(Text, { className: "form-toggle-badge", value: badge }))),
        React.createElement(FormFieldError, { error: error })));
}
